import React from 'react';
import { ApplicationState } from '../../reducers';
import { useDispatch, useSelector } from 'react-redux';
import { ComponentManagementActionType } from '../../reducers/comp.actions';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';

type Props = {
    onConfirm: () => void
}

const ApproveAllNodeDialog: React.FC<Props> = ({onConfirm}) => {

    const open = useSelector((app: ApplicationState) => app.comp.approveAllDialogOpen);
    const dispatch = useDispatch();


    const onCancel = () => {
        dispatch({type: ComponentManagementActionType.APPROVE_ALL_NODE_DIALOG_OPEN, open: false })
    }

    const onApproveAll = () => {
        dispatch({type: ComponentManagementActionType.APPROVE_ALL_NODE_DIALOG_OPEN, open: false })
        onConfirm();
    }

    return(
        <Dialog maxWidth='sm' fullWidth={true} open={open} onClose={() => {}}>
            <DialogTitle disableTypography={true}>
                <Typography variant='h4'>Approve All</Typography>
            </DialogTitle>
            <DialogContent>
                Are you sure you want to Approve the Provision and its associated children?
            </DialogContent>
            <DialogActions>
                <Button size='small' variant='outlined' color='primary' onClick={onApproveAll}>Yes</Button>
                <Button size='small' variant='outlined' color='secondary' onClick={onCancel}>No</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ApproveAllNodeDialog;
